<template>
  <div class="roles">
    <v-toolbar flat color="white" class="mb-4">
      <v-toolbar-title>{{ $t("headings.roles") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="roles"
      hide-default-footer
      :mobile-breakpoint="zero"
      disable-pagination
    >
      <!-- slot="items" slot-scope="props" -->
      <template v-slot:item="props">
        <tr>
          <td class="td_name text-center" :title="props.item.name">
            {{ props.item.name }}
          </td>
          <td class="td_desc text-center" :title="props.item.description">
            {{ props.item.description }}
          </td>
          <td class="text-center">
            <v-btn icon :to="`/roles/${props.item.id}/edit`">
              <v-icon class="mr-2 edit" title="Edit Permissions" small>
                mdi-pencil
              </v-icon>
            </v-btn>
            <v-icon
              @click="deleteRole(props.item.id, props.index)"
              class="delete"
              title="Delete Permissions"
              small
              >mdi-delete</v-icon
            >
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { indexRoles, deleteRole } from "@/api/roles.js";
import { myMixins } from "@/components/Mixins.js";

export default {
  components: {},
  mixins: [myMixins],
  data() {
    return {
      roles: [],
      headers: [
        {
          text: this.$t("table.name"),
          sortable: false,
          value: "name",
          align: "center"
        },
        {
          text: this.$t("table.description"),
          value: "Description",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("table.actions"),
          value: "Description",
          sortable: false,
          align: "center"
        }
      ],
      zero: 0
    };
  },
  created() {
    indexRoles()
      .then(res => {
        const { roles } = res.data;
        this.roles = roles;
      })
      .catch(err => console.log(err));
  },
  methods: {
    deleteRole(id, index) {
      this.popUp(this.$t("messages.warning"), "warning").then(value => {
        if (!value.dismiss) {
          deleteRole(id)
            .then(() => {
              this.$delete(this.roles, index);
            })
            .catch(err => console.log(err));
        }
      });
    }
  }
};
</script>
